import { useQuery } from '@tanstack/react-query';
import { useLocale } from '@/app/[lang]/providers/LocaleProvider';
import { fetchNavigationMenu, type NavigationNode } from '@/services/navigation.service';

export type { NavigationNode, RawNavigationNode } from '@/services/navigation.service';

export function useNavigationMenu() {
  const lang = useLocale();

  return useQuery<NavigationNode[]>({
    queryKey: ['navigations', lang],
    queryFn: () => fetchNavigationMenu(lang),
  });
}

export type UseNavigationMenuResult = ReturnType<typeof useNavigationMenu>;
